import React from 'react';
import { Modal } from 'react-bootstrap-v5';

interface ConfirmationModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  title?: string;
  message: string | React.ReactElement;
  confirmButtonText?: string;
  cancelButtonText?: string;
  isLoading?: boolean;
  confirmButtonVariant?: 'primary' | 'danger' | 'warning' | 'success';
}

const IPConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  onHide,
  onConfirm,
  title = 'Onay',
  message,
  confirmButtonText = 'Onayla',
  cancelButtonText = 'İptal',
  isLoading = false,
  confirmButtonVariant = 'primary',
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{title}</h5>
          <button type="button" className="btn-close" onClick={onHide}></button>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onHide}>
            {cancelButtonText}
          </button>
          <button
            type="button"
            disabled={isLoading}
            className={`btn btn-${confirmButtonVariant}`}
            onClick={onConfirm}
          >
            {confirmButtonText}
            {isLoading && <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default IPConfirmationModal; 